
qx.Class.define('cv.Version', {
  type: 'static',

  statics: {
    REV: '112834912c16e9b9b7ee16c487fd8da4093e92be',
    BRANCH: 'HEAD',
    VERSION: '1.0.0-dev',
    LIBRARY_VERSION_PURE: 9,
    LIBRARY_VERSION_TILE: 1,
    DATE: '2026-10-04T13:33:06.218Z',
    TAGS: { 
    }
  }
});    
